export const IsCityLpPage = [
  "/lp-nw/lucknow",
  "/lp-nw/kanpur",
  "/lp-nw/gorakhpur",
  "/lp-nw/varanasi",
  "/lp-nw/prayagraj",

];

